export default "__VITE_ASSET__CvKubjP6__"